import { createContext, useContext } from 'react';

// Soft-launch invite gate state for the marketplace chrome (Nav, MobileBottomNav, Footer, LoginPage,
// install banner). Provided by InviteGateProvider in App.jsx.
//   gateEnabled — INVITE_GATE_ENABLED is on (GET /invites/gate-status)
//   locked      — gate on and the visitor is neither logged in nor invite-unlocked. While locked, only
//                 the account pages (/login, /forgot-password, /reset-password, /verify-email) and an
//                 emailed guest order link render the marketplace Layout; every marketplace route shows
//                 InviteSplash, so the chrome hides links that would only lead back to the splash.
//   enterInvite — opens InviteSplash (null when not locked)
export const InviteGateContext = createContext({ gateEnabled: false, locked: false, enterInvite: null });

export function useInviteGate() {
  return useContext(InviteGateContext);
}
